import { Icon } from '@chakra-ui/react';

export const MageSvg = ({
  size = 18,
  theme = 'light',
}: {
  size?: number;
  theme?: 'light' | 'dark';
}): JSX.Element => {
  const color = theme === 'light' ? 'white' : 'black';

  return (
    <Icon
      fill={color}
      height={size}
      viewBox="0 0 19 18"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_548_4077)">
        <path d="M15.1054 -0.00010268C14.6514 1.37915 14.2412 2.62667 13.8285 3.8742C13.6273 4.48117 13.4545 5.09589 13.2197 5.68995C12.936 6.41574 13.0108 7.09245 13.3152 7.79241C14.2902 10.0343 15.2447 12.2866 16.23 14.5931H9.02281C9.2395 13.1079 10.6969 13.064 11.6926 12.346C10.9704 11.9792 10.1294 11.7545 9.59805 11.225C9.04861 10.6801 8.79839 9.83287 8.37019 9.0296C7.98584 9.77863 7.75884 10.6181 7.22488 11.1501C6.6806 11.6951 5.83709 11.9431 5.0787 12.346C6.02023 13.0666 7.49573 13.0899 7.73563 14.6008H2.77002C3.26787 13.467 3.75798 12.346 4.25583 11.225C5.00906 9.53067 5.7855 7.84923 6.51293 6.14454C6.9953 5.01324 7.75368 4.17123 8.81645 3.572C10.8749 2.41488 12.9231 1.23967 15.1028 -0.00268555L15.1054 -0.00010268Z" />
        <path d="M9.46647 18.0001C6.80697 18.0001 4.14747 18.0001 1.48797 18.0001C0.641881 18.0001 0.507745 17.8555 0.502586 16.9773C0.494847 15.8667 0.595449 15.7246 1.45701 15.7246C6.81987 15.722 12.1801 15.722 17.543 15.7246C18.402 15.7246 18.5052 15.8718 18.5 16.9799C18.4948 17.8503 18.353 18.0001 17.5095 18.0001C14.8293 18.0001 12.1466 18.0001 9.46647 18.0001Z" />
      </g>
      <defs>
        <clipPath id="clip0_548_4077">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};
